import React, { Component } from 'react';
import { PropTypes } from 'prop-types';

import { DropDownMenu, MenuItem } from 'material-ui';

class UtilityList extends Component {
    static propTypes = {
        isLocked: PropTypes.bool.isRequired,
        projectState: PropTypes.number.isRequired,
        provider: PropTypes.string.isRequired,
        setUtilityProvider: PropTypes.func.isRequired,
    };

    handleUtilityChange(value) {
        const { setUtilityProvider } = this.props;
        setUtilityProvider(value);
    }

    render() {
        const { projectState, isLocked, provider } = this.props;

        return (
            <div>
                {projectState === 1 ? (
                    <DropDownMenu
                        fullWidth
                        label="Utility Company"
                        value={provider}
                        onChange={(e, index, value) => this.handleUtilityChange(value)}
                        disabled={isLocked}

                    >
                        <MenuItem value="selectProvider" primaryText="Select Provider" />
                        <MenuItem value="LADWP" primaryText="LADWP" />
                        <MenuItem value="PG&E" primaryText="PG&E" />
                        <MenuItem value="SCE" primaryText="SCE" />
                        <MenuItem value="SDG&E" primaryText="SDG&E" />
                    </DropDownMenu>
                ) : null}
                {projectState === 2 ? (
                    <DropDownMenu
                        fullWidth
                        label="Utility Company"
                        value={provider}
                        onChange={(e, index, value) => this.handleUtilityChange(value)}
                        disabled={isLocked}
                    >
                        <MenuItem
                            value="selectProvider"
                            primaryText="Select Provider"
                        />
                        <MenuItem value="Eversource" primaryText="Eversource" />
                        <MenuItem value="National Grid" primaryText="National Grid" />
                        <MenuItem value="Utility" primaryText="Other" />
                    </DropDownMenu>
                ) : null}
                {projectState === 3 ? (
                    <DropDownMenu
                        fullWidth
                        label="Utility Company"
                        value={provider}
                        onChange={(e, index, value) => this.handleUtilityChange(value)}
                        disabled={isLocked}
                    >
                        <MenuItem value="selectProvider" primaryText="Select Provider" />
                        <MenuItem value="ACE" primaryText="ACE" />
                        <MenuItem value="JCP&L" primaryText="JCP&L" />
                        <MenuItem value="PSE&G" primaryText="PSE&G" />
                    </DropDownMenu>
                ) : null}
                {projectState === 5 ? (
                    <DropDownMenu
                        fullWidth
                        label="Utility Company"
                        value={provider}
                        onChange={(e, index, value) => this.handleUtilityChange(value)}
                        disabled={isLocked}
                    >
                        <MenuItem value="selectProvider" primaryText="Select Provider" />
                        <MenuItem value="FPL" primaryText="FPL" />
                        <MenuItem value="DukeEnergy" primaryText="Duke Energy" />
                    </DropDownMenu>
                ) : null}
                {projectState === 4 ? (
                    <DropDownMenu
                        fullWidth
                        label="Utility Company"
                        value={provider}
                        onChange={(e, index, value) => this.handleUtilityChange(value)}
                        disabled={isLocked}
                    >    <MenuItem value="selectProvider" primaryText="Select Provider" />
                        <MenuItem value="ConEd" primaryText="Con Edison" />
                        <MenuItem value="Utility" primaryText="Other" />
                    </DropDownMenu>
                ) : null}

            </div>
        );
    }
}

export default UtilityList;



// WEBPACK FOOTER //
// ./src/containers/Inputs/UtilityInputs/UtilityList/UtilityList.js